export const STEP_SIDEBAR_DROP_ZONE_ID = 'item-list-container';
